<template>
  <div class="adminUserList">
    <Breadcumb :title="$t('surveys_list')" :breadcumb-data="breadcumbData">
      <b-btn
              v-if="user.userprofile.user_type.slug == 'pilote_global' || user.userprofile.user_type.slug == 'pilote_survey' || user.userprofile.user_type.slug == 'obea_admin'"
              v-bind:to="'/survey/add/'" variant="primary" style="float:right">{{ $t(('create_survey'))}}
      </b-btn>
    </Breadcumb>
    <b-card no-body class="cardcontainer">
      <!-- Table controls -->
      <b-card-body>
        <b-table
                :items="surveysData"
                :fields="fields"
                :striped="true"
                :bordered="true"
                class="card-table">

          <template :slot="$t('label')" slot-scope="data">
            {{data.item.label}}
          </template>
          <template :slot="$t('publication_date')" slot-scope="data">
            {{ data.item.publication_date|formatDateNoH }} -  {{ data.item.publication_end|formatDateNoH }}
          </template>
          <template :slot="$t('state')" slot-scope="data">
            <b-badge variant="outline-success" v-if="data.item.state === 'COM'">{{ $t('created')}}</b-badge>
            <b-badge variant="outline-warning" v-if="data.item.state === 'INC'">{{ $t('draft')}}</b-badge>
          </template>
          <template slot="Actions" slot-scope="data">
            <b-btn v-on:click="onexport(data.item.id)" variant="default btn-xs md-btn-flat">
              {{ $t('download_question')}}
            </b-btn>
            <b-btn v-if="data.item.state === 'INC'" v-on:click="continueSurvey(data.item.id)" variant="warning btn-xs md-btn-flat">
              {{ $t('modify_survey')}}
            </b-btn>
            <b-btn v-if="data.item.state === 'COM'" v-on:click="continueSurvey(data.item.id)" variant="warning btn-xs md-btn-flat">
              {{ $t('modify_survey')}}
            </b-btn>
            <b-btn v-if="data.item.state === 'COM'" v-on:click="duplicateSurvey(data.item.id)" variant="default btn-xs  md-btn-flat">
              {{ $t('duplicate_survey')}}
            </b-btn>
          </template>
        </b-table>
        <sweet-modal width="80%" ref="formodal" height="80%">
          <form @submit="addTargetFile">
            <b-form-group :label="$t('collaborator_file')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-file v-model="document" ref="document"/>
            </b-form-group>
            <b-btn type="submit" variant="primary" slot="finish">Ajouter</b-btn>
          </form>
        </sweet-modal>
        <sweet-modal width="80%" ref="companiesmodal" height="80%">
          <b-badge variant="outline-default" v-for="company in companies">{{ company.name }}</b-badge>
        </sweet-modal>
        <sweet-modal width="80%" ref="languagemodal" height="80%">
          <template v-if="$cookie.get('language') == 'en'">
            <b-badge variant="outline-default" v-for="language in languages">{{ language.name_en }}</b-badge>
          </template>
          <template v-if="$cookie.get('language') == 'fr'">
            <b-badge variant="outline-default" v-for="language in languages">{{ language.name }}</b-badge>
          </template>
          
        </sweet-modal>
        <sweet-modal width="80%" ref="notobea" height="80%">
          <span v-html="$t('collab_file_disclaimer')"></span>
          
        </sweet-modal>
      </b-card-body>
    </b-card>
  </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<script>
  import {
    GET_SURVEY_REQUEST,
    GET_SURVEYS_REQUEST,
    RRH_CUSTOM_TEMPLATE_REQUEST,
    SURVEY_ADD_TARGETS_REQUEST
  } from '../_store/survey/actiontypes'
  import XLSX from 'xlsx';
  import Breadcumb from '../components/breadcumb'
  import slugify from 'slugify'
  import {SweetModal, SweetModalTab} from 'sweet-modal-vue'
  import {mapState} from 'vuex';

  function pdfBlobConvesion(b64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    var byteCharacters = window.atob(b64Data);
    var byteArrays = [];
  
    for ( var offset = 0; offset < byteCharacters.length; offset = offset + sliceSize ) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
    
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
    
      var byteArray = new Uint8Array(byteNumbers);
    
      byteArrays.push(byteArray);
    }
  
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      if (file === undefined) {
        return resolve(null);
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      }
    });
  }

  export default {
    name: 'adminUserList',
    computed: mapState({user: state => state.user.user}),
    mounted() {
      this.fields = [
        {
          key: this.$t('label'),
          sortable: false,
          tdClass: 'align-middle'
        },
        {
          key: this.$t('publication_date'),
          sortable: false,
          tdClass: 'align-middle'
        },
        {
          key: this.$t('state'),
          sortable: false,
          tdClass: 'align-middle'
        },
        {
          key: 'Actions',
          sortable: false,
          tdClass: 'align-middle'
        }
      ];
      this.breadcumbData = [
        { text: this.$t('welcome'), href: '/dashboard/' },
        { text: this.$t('surveys_list'), active: true },
      ];
      this.$store.dispatch(GET_SURVEYS_REQUEST)
        .then(response => {
          this.surveysData = response.data.surveys
        })
    },
    components: { Breadcumb, SweetModal, SweetModalTab},
    data() {
      return {
        breadcumbData: [],
        dataUrl: 'json/pages_users_list.json',
        fields: [],
        surveysData: [],
        currentPage: 1,
        companies: [],
        languages: [],
        document: false,
        survey_id: false
      };
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      downloadTemplate(survey_id) {
        this.$store.dispatch(RRH_CUSTOM_TEMPLATE_REQUEST, survey_id)
                .then(response => {
                  console.log(response.data);
                  let file = response.data.encoded_string.file;
                  let type = file.split(';')[0].split('/')[1];
                  let original_type = type;
                  if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                    type = "xlsx";
                  }
                  const linkSource = file;
                  const downloadLink = document.createElement("a");
                  const fileName = survey_id + "_template-population-list.xlsx";
                  downloadLink.href = linkSource;
                  downloadLink.download = fileName;
                  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                  }
                  else {
                    downloadLink.click();
                    document.body.appendChild(downloadLink);
                  }
                })
                .catch(error => {
                  console.log("ERROR is ====");
                  console.log(error)
                })
      },
      downloadTargets(survey_id) {
        this.$store.dispatch(GET_SURVEY_REQUEST, survey_id)
                .then(response => {
                    console.log("I GOT SURVEY")
                    let survey = response.data.survey;
                    let type = survey.targets.split(';')[0].split('/')[1];
                    let original_type = type;
                    if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                      type = "xlsx";
                    }
                    const linkSource = survey.targets;
                    const downloadLink = document.createElement("a");
                    const fileName = slugify(survey.label, '_') + "_" + survey.id + "." + type;
                    console.log(fileName);
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                      window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                    }
                    else {
                      document.body.appendChild(downloadLink);
                      downloadLink.click();
                    }
                })
                .catch(error => {
                  console.log("ERROR is ====");
                  console.log(error)
                })
      },
      addTargetFile: function (e) {
        e.preventDefault();
        console.log(this.survey_id);
        getBase64(this.$refs.document.$el.querySelector('input[type=file]').files[0])
                .then(documentB64 => {
                  this.document = documentB64;
                  this.$store.dispatch(SURVEY_ADD_TARGETS_REQUEST, {
                    "targets": this.document,
                    "id": this.survey_id
                  })
                  .then(() => {
                    this.$store.dispatch(GET_SURVEYS_REQUEST)
                            .then(response => {
                              this.surveysData = response.data.surveys
                              this.$refs.formodal.close()
                            })
                  })
                })
      },
      duplicateSurvey(survey_id){
        this.$router.push('/survey/add/' + survey_id)
      },
      continueSurvey(survey_id){
        this.$router.push('/survey/edit/' + survey_id)
      },
      onexport (survey_id) { // On Click Excel download button
        var wb = XLSX.utils.book_new();
        this.$store.dispatch(GET_SURVEY_REQUEST, survey_id)
                .then(response => {
                  let survey = response.data.survey;
                  return Promise.all(survey.questions.map(question => {
                    return Promise.all(question.qtranslations.map(translation => {
                        if (question.is_mandatory === true)
                          question.is_mandatory = "TRUE";
                        if (question.is_mandatory === false)
                          question.is_mandatory = "FALSE";
                        let questionReturn = {
                          'label': translation.label,
                          'is_mandatory': question.is_mandatory,
                          'type': ''
                        };
                        if (question.type === 'TFREE'){
                          if (translation.language.slug === 'fr'){
                            questionReturn.type = "Réponse libre"
                          } else {
                            questionReturn.type = "Free answer"
                          }
                          
                        } else if (question.type === 'TMULT'){
                            if (translation.language.slug === 'fr'){
                              questionReturn.type = "Choix multiple"
                            } else {
                              questionReturn.type = "Multiple choice"
                            }
                        } else if (question.type == 'TSING') {
                          if (translation.language.slug === 'fr'){
                            questionReturn.type = "Choix simple"
                          } else {
                            questionReturn.type = "Simple choice"
                          }
                        }
                        for (let index = 0; index < translation.answers.length; index++) {
                          questionReturn['answer_' + (index + 1)] = translation.answers[index].label;
                        }
                        return questionReturn;
                    }))
                    .then(translateReturns => {
                      return translateReturns.filter(tr => tr !== undefined)[0]
                    })
                  }))
                    .then(questions => {
                      console.log("I THEN QUESTIONS");
                      console.log(questions);
                      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(questions), "fr");
                      XLSX.writeFile(wb, 'survey_'+ survey.publication_date+'_'+ slugify(survey.label, '_') + '.xlsx');
                    })
                    .catch(error => {
                      console.log("ERROR GENERATING FILE")
                      console.log(error);
                    })
                })
        }
    },
  };
</script>

